import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface AvailableManager {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
}

export const getAvailableManager = async () => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('client-employees/', {
    headers: {
      Authorization: token,
    },
  });

  return data.data as AvailableManager[];
};
